module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/template-activation/thumbtack_green.svg"